import {Button, closeCurrentDialog} from 'platform/components';
import {Box, Right, VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  PreviewCustomerMessages,
  useRenderCustomerMessageEmailTemplateV2Mutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';
import {EmailWindow} from '@dms/shared-aftersales';

import {useOnMount} from 'shared/web';

interface EmailPreviewProps {
  body: string;
  subject: string;
  locale: string;
  customerMessageId: PreviewCustomerMessages;
}

export function EmailPreview(props: EmailPreviewProps) {
  const [renderEmail, {isLoading}] = useRenderCustomerMessageEmailTemplateV2Mutation();

  const [htmlData, setHtmlData] = useState<string | null>(null);

  const handleRenderEmail = () => {
    renderEmail?.({
      customerMessageId: props.customerMessageId,
      renderCustomerMessageRequestBodyV2: {
        locale: props.locale,
        customerId: null,
        payload: {
          customerMessageId: props.customerMessageId,
          context: null,
          emailContextTemplate: {
            subject: props.subject,
            body: props.body,
          },
        },
      },
    })
      .unwrap()
      .then((data) => data.body)
      .then(setHtmlData)
      .catch(handleApiError);
  };

  useOnMount(handleRenderEmail);

  return (
    <VStack spacing={4}>
      <Box position="relative" height={180} maxHeight="80vh">
        <VStack height="100%">
          <Box position="relative" height="100%">
            <EmailWindow
              htmlData={htmlData}
              isRerendering={isLoading && isNotNilOrEmpty(htmlData)}
              data-testid="customerEmailForm-email-window"
            />
          </Box>
        </VStack>
      </Box>
      <Right>
        <Button
          title={i18n.t('general.actions.close')}
          onClick={closeCurrentDialog}
          variant="secondary"
        />
      </Right>
    </VStack>
  );
}
